const registration = {
  registration: {
    backButton: 'Voltar para Login Enlighten',
    pageHeader: 'Registro de novo usuário',
    installerNote:
      'Entre em contato com o administrador da sua empresa/filial para que o seu ID de usuário possa ser criado',
    registerOption: 'Quero registrar uma nova empresa integradora na Enphase',
    installerOption: 'Sou um instalador que trabalha para uma empresa que já instalou um sistema Enphase',
    doItYourselfOption: 'Sou um profissional independente instalando produtos Enphase',
    homeownerOption: 'Sou o proprietário de um sistema solar fotovoltaico',
    updateSignuppage: 'Concordo que a Enphase pode contactar-me por meio de chamadas e mensagens de texto pelo número de telefone introduzido acima para informações do sistema, atualizações, ou mensagens de marketing relacionadas com o meu sistema. Estas chamadas e textos de marketing podem ser automaticamente marcadas ou geradas por uma voz artificial ou pré-gravada. O meu consentimento para estas comunicações não é uma condição necessária para qualquer compra e pode ser revogado em qualquer momento e por qualquer meio razoável.',
    termsAndServices: 'Li a %{privacyPolicy} da Enphase e li e aceito os %{termsService}',
    termsServicesSafetyDisclaimer:
      'Eu reconheço que li e concordo com os termos da Enphase: %{safetyDisclaimer}, %{privacyPolicy} e %{termsService}',
    safetyDisclaimer: 'Isenção de responsabilidade de segurança',
    accountHeader: 'Detalhes da sua conta',
    companyDetails: 'Detalhes da Empresa',
    firstName: 'Primeiro nome',
    lastName: 'Sobrenome',
    country: 'País',
    email: 'E-mail',
    verificationHeader: 'Digite o código de verificação',
    verificationNote: 'Digite o código de verificação de seis dígitos enviado para %{email}',
    didntReceivedOtp: 'Não recebeu o código de verificação?',
    resendOtp: 'Reenviar código de verificação',
    setPasswordHeader: 'Defina sua senha do Enlighten',
    setPasswordNote: 'Deve ter entre 6 e 50 caracteres e conter pelo menos 1 número ou caractere especial.',
    password: 'Senha',
    confirmPassword: 'Confirmar a senha',
    safetyDisclaimerNote:
      'A instalação, serviço e manutenção dos produtos Enphase devem ser realizados apenas por pessoal qualificado. O trabalho elétrico deve ser executado por eletricistas licenciados, treinados no código elétrico aplicável à região ou território, e com conhecimento dos requisitos legais e das considerações de segurança associadas aos sistemas solares, de armazenamento e de gerenciamento de energia. Sempre consulte os manuais e guias de instalação.',
    fieldRequired: 'Este campo é obrigatório.',
    validEmail: 'Por favor insira um endereço de e-mail válido.',
    validPhone: 'Digite um número válido de telefone.',
    companyName: 'Nome da empresa',
    streetAddress: 'Endereço',
    streetAddress2: 'Endereço 2',
    city: 'Cidade',
    state: 'Estado',
    zip: 'CEP/Código Postal',
    supportEmail: 'E-mail de Suporte ao Cliente',
    supportPhone: 'Telefone de Suporte ao Cliente',
    wesbiteUrl: 'URL do site',
    companyLogo: 'Logotipo da Empresa',
    chooseFile: 'Escolher arquivo',
    noFile: 'Nenhum arquivo selecionado',
    chooseFileNote:
      'Deve ser um arquivo JPEG, GIF ou PNG de até 4 MB. Para melhores resultados, recomendamos uma imagem quadrada com fundo transparente de pelo menos 400 px de largura por 400 px de altura.',
    enphaseInstaller: 'Esta empresa instala ou planeia instalar sistemas Enphase',
    privacyPolicy: 'Política de Privacidade',
    termsService: 'Termos de serviço',
    andText: 'e',
    accountNote:
      'Nota:todos os sistemas adicionados a essa conta não serão associados a nenhuma empresa instaladora',
    phone: 'Telefone',
    passwordMismatch: 'As senhas inseridas nos campos acima devem corresponder umas às outras',
    updateSignupError: 'Selecione a caixa de seleção acima para prosseguir com o registro',
    privaryPolicyError:
      'Se não concordar com os termos da Política de Privacidade e Termos de Serviço da Enphase, você não pode se registrar no Enlighten.',
    otpSuccess: 'Código de verificação reenviado com sucesso',
    registrationSuccess: 'Sua conta do Enlighten foi criada com sucesso',
    registrationSuccessRedirection: 'Você foi registrado com sucesso no Enlighten. Fazendo login...',
    login: 'Conecte-se',
    warningName:
      'Aviso: Já existe uma empresa com este nome no sistema. Para garantir o acesso correto, entre em contato com o administrador da sua empresa/filial para criar seu ID de usuário ou entre em contato com o suporte da Enphase.',
    errorName:
      'Já existe uma empresa com este nome no sistema. Para garantir o acesso correto, entre em contato com o administrador da sua empresa/filial para criar seu ID de usuário ou entre em contato com o suporte da Enphase.',
    warningAddress:
      'Aviso: Este endereço está associado a uma empresa já existente no sistema. Para garantir o acesso correto, entre em contato com o administrador da sua empresa/filial para criar seu ID de usuário ou entre em contato com o suporte da Enphase.',
    errorSupportEmail:
      'Este e-mail ID está associado a uma empresa que já existe no sistema. Para garantir o acesso correto, entre em contato com o administrador da sua empresa/filial para criar seu ID de usuário ou entre em contato com o suporte da Enphase.',
    errorSupportPhone:
      'Este número de telefone está associado a uma empresa já existente no sistema. Para garantir o acesso correto, entre em contato com o administrador da sua empresa/filial para criar seu ID de usuário ou entre em contato com o suporte da Enphase.',
    warningUrl:
      'Este link de site está associado a uma empresa já existente no sistema. Para garantir o acesso correto, entre em contato com o administrador da sua empresa/filial para criar seu ID de usuário ou entre em contato com o suporte da Enphase.',
    errorPhone:
      'Este número de telefone já está associado a uma conta existente. Use um número de contato diferente ou entre em contato com o Suporte da Enphase.',
    errorEmail:
      'Este endereço de e-mail já está associado a uma conta existente. Use um endereço de e-mail diferente ou entre em contato com o Suporte da Enphase.',
    streetNumberEmptyError: 'Número da rua não encontrado, verifique antes de salvar.',
    recaptchaError: 'Conclua a verificação do reCAPTCHA para continuar.',
    infoText: 'Certifique-se de que o marcador seja colocado no local exato.',
    warningText: 'Certifique-se de colocar o marcador no local exato.',
    locateMeText: 'Use o botão localizar-me para obter sua localização atual.',
    addressCheckText: 'Certifique-se de inserir o endereço correto',
    markerText: 'Coloque o marcador no local exato',
    mapErrorText: 'Desculpe! Não foi possível localizar você no Google Maps.',
    validChamberNumber: 'Entrada inválida! O número da Câmara de Comércio tem de ter, pelo menos, 8 carateres',
    chamberofcommerce: 'Número da Câmara de Comércio',
  }
};

export default registration;
